import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Box,
    Button,
    Menu,
    MenuItem,
    useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/w-logo 1@2x.png"; // Path to your logo
import MenuIcon from "@mui/icons-material/Menu"; // Import Material-UI's Menu icon
import { CHATAREA } from "../Routes/constURL";

const Header = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:600px)"); // Media query for mobile
    const [anchorEl, setAnchorEl] = useState(null); // State for menu anchor
    const useStyles = makeStyles((theme) => ({
        appBar: {
            background:
                "linear-gradient(to right, rgb(53, 66, 255) 0%,#B87DFF, rgb(85, 247, 255) 100%) !important",
            padding: "5px 5px",
            paddingRight: "20px",
            margin: "10px",
            borderRadius: "50px",
            "&.MuiAppBar-root": {
                width: "auto",
                boxShadow: "none",
            },
        },
        logo: {
            width: "40px",
        },
        navLinks: {
            display: "flex",
            gap: "100px",
            flexGrow: 1,
            justifyContent: "flex-end",
            "@media (max-width: 900px)": {
                gap: "50px",
            },
            "@media (max-width: 600px)": {
                display: "none", // Hide links in mobile view
            },
        },
        navButton: {
            textTransform: "none",
            fontWeight: 600,
            position: "relative", // To position the hover effect
            overflow: "hidden", // Hide overflow of the gradient
            "&.MuiButton-root": {
                color: "white",
                fontWeight: 600,
                textTransform: 'none',
                    fontSize: "18px",
                "@media (max-width: 600px)": {
                    fontSize: "0.8rem",
    
                },
            },
    
        },
        iconButton: {
            width: "45px",
            "&.MuiIconButton-root": {
                backgroundColor: "white",
                width: "50px",
                height: "50px",
                "&:hover":{
                backgroundColor: "white",
    
                }
            }
        },
        toolbar: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            "&.MuiToolbar-root": {
                minHeight: "40px",
                paddingLeft: "15px",
                paddingRight: isMobile?"5px":"95px",
    
            }
        },
        menuButton: {
            display: "none", // Hide menu button by default
            "@media (max-width: 600px)": {
                display: "block", // Show menu button in mobile view
            },
           
        },
        link: {
            "&:hover": {
                color: "white",
                background: "linear-gradient(to right, rgb(53, 66, 255) 0%, #B87DFF, rgb(85, 247, 255) 100%)", // Gradient on hover
                borderRadius: "5px", // Rounded corners
            },
        }
    }));
    const classes = useStyles();
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleNavigate = (path) => {
        navigate(path);
        handleMenuClose(); // Close menu after navigating
    };

    return (
        <AppBar position="static" className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                {/* Logo */}
                <IconButton
                    edge="start"
                    className={classes.iconButton}
                    aria-label={t("logo")} // Accessible aria label
                    onClick={() => navigate(CHATAREA)}
                >
                    <img src={Logo} alt="logo" className={classes.logo} />
                </IconButton>

                {/* Navigation Links for desktop */}
                <Box className={classes.navLinks}>
                    <Button className={classes.navButton} onClick={() => navigate("/comefunziona")}>
                        {t("header.how_it_works")}
                    </Button>
                    <Button className={classes.navButton} onClick={() => navigate("/contatti")}>
                        {t("header.contacts")}
                    </Button>
                    <Button
                        className={classes.navButton}
                        target="_blank"
                        onClick={() => window.open("https://clink.team/", "_blank")}
                    >
                        {t("header.clink")}
                    </Button>
                </Box>

                {/* Hamburger Menu for mobile */}
                {isMobile && <IconButton
                    className={classes.menuButton}
                    color="inherit" // Set color to inherit so it takes on the AppBar's color
                    onClick={handleMenuOpen}
                >
                    <MenuIcon style={{ color: "white" }} /> {/* Set icon color to white */}
                </IconButton>}
            </Toolbar>

            {/* Dropdown Menu */}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={() => handleNavigate("/comefunziona")}
                className={classes.link}
                >
                    {t("header.how_it_works")}
                </MenuItem>
                <MenuItem onClick={() => handleNavigate("/contatti")}
                className={classes.link}
                >
                    {t("header.contacts")}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        window.open("https://clink.team/", "_blank");
                        handleMenuClose(); // Close menu after opening link
                    }}
                className={classes.link}
                >
                    {t("header.clink")}
                </MenuItem>
            </Menu>
        </AppBar>
    );
};

export default Header;
